import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'antd'
import Chart from 'react-apexcharts'
import dayjs from '../../lib/datetime'
import { formatCycleRange } from '../../lib/cycles'

export default function ConnectivityRatesChart({ rates }) {
  const chartOptions = useMemo(() => {
    const colors = [
      '#3695dc',
    ]
    return ({
    chart: {
      type: 'line',
      sparkline: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      stacked: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
      width: [2, 0, 0, 0],
    },
    fill: {
      type: ['solid', 'solid', 'solid', 'solid'],
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
        dataLabels: {
          position: 'top',
        },
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
        },
      },
    },
    grid: {
      show: false,
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      clusterGroupedSeries: false,
    },
    markers: { size: [5, 0, 0, 0], shape: 'square' },
    xaxis: {
      categories: rates.map(rate => dayjs(rate.cycle.endsAt).format('MMM YYYY')),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      type: 'category',
    },
    yaxis: [
      {
        seriesName: 'Connectivity Rate',
        labels: {
          formatter(value) {
            return `${Math.round(value)}%`
          },
        },
        min: 0,
        max: rates.reduce((max, rate) => Math.max(max, rate.conectivityRate * 100), 0),
        title: {
          text: 'Connectivity Rate (%)',
        },
      },
    ],
    colors,
    tooltip: {
      x: {
        formatter(_, { dataPointIndex }) {
          const rate = rates[dataPointIndex]
          return formatCycleRange(rate.cycle)
        },
      },
      y: {
        formatter(value, { seriesIndex }) {
          if (seriesIndex === 0) {
            return `${value}%`
          }
          return `${Math.round(value)}`
        },
      },
    },
    })
  }, [rates])

  const chartSeries = [
    {
      name: 'Connectivity Rate',
      data: rates.map(rate => rate.conectivityRate * 100),
      type: 'line',
      yAxisIndex: 0,
    },
  ]

  return (
    <Row gutter={[0, 50]}>
      <Col span={24}>
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="line"
          height={350}
        />
      </Col>
    </Row>
  )
}

ConnectivityRatesChart.propTypes = {
  rates: PropTypes.arrayOf(
    PropTypes.shape({
      cycle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        startsAt: PropTypes.string.isRequired,
        endsAt: PropTypes.string.isRequired,
      }).isRequired,
      conectivityRate: PropTypes.number.isRequired,
    }),
  ).isRequired,
}
